import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { ReportGroupsApiService } from './report-groups-api.service';
import { DevicesPayload } from '../../../equipment/devices/components/devices.models';
import { ReportGroupsTable, ReportGroups } from '../report-groups.types';
import { ReportGroupsFieldName } from '../report-groups.constants';
import { TimezoneService } from 'src/app/services/utility/timezone.service';

@Injectable({
  providedIn: 'root'
})
export class ReportGroupsService {
  private readonly apiService = inject(ReportGroupsApiService);

  private readonly timeZoneService = inject(TimezoneService);

  getTableData(tableState: DevicesPayload): Observable<ReportGroupsTable> {
    return this.apiService.getAll(tableState).pipe(
      map(({ items, totalCount }) => {
        const data = items?.map((item: ReportGroups) => {
          return {
            ...item,
            status: item.groupStatus,
            commodity: item.groupAttributes.find(el => el.name === ReportGroupsFieldName.Commodity)?.values[0],
            applicable: item.groupAttributes
              .find(el => el.name === ReportGroupsFieldName.Applicable)
              ?.values.join(', '),
            updatedOn: item.updatedOn ? this.timeZoneService.formatLong(item.updatedOn) : item.updatedOn,
            deviceCount: item.deviceCount
          };
        });
        return { data: data, total: totalCount };
      }),
      catchError(() => of({ data: [], total: 0 }))
    );
  }
}
